module.exports = __webpack_public_path__ + "public/images/slider/oleynikova.6394f913505d8d8bbef092ae79e9497a.webp";